const home = {
  hero: {
    title: {
      line1: 'Haz Crecer Tu',
      line2: 'Negocio Digital',
      line3: 'con IA & Redes Sociales'
    },
    description: 'Ayudamos a emprendedores y dueños de negocios a escalar, automatizar y dominar el mundo digital con estrategias de marketing digital y herramientas de IA.',
    buttons: {
      start: 'Comenzar Ahora',
      services: 'Ver Servicios'
    },
    miniStats: {
      students: 'Estudiantes',
      clients: 'Clientes',
      years: 'Años'
    }
  },
  aboutPreview: {
    badge: 'Conoce a tu Mentora',
    subtitle: 'Emprendedora · Mentora Digital · Educadora',
    desc1: 'Con más de 8 años de experiencia en marketing digital, Cathy ha ayudado a cientos de emprendedores latinos a construir negocios rentables en línea. Su misión es empoderar a la comunidad latina con las herramientas y conocimientos del mundo digital.',
    desc2: 'Especialista en redes sociales, automatización con IA, y estrategias de negocio digital. Fundadora de Smart Business Academy, la plataforma educativa para emprendedores hispanos.',
    tags: ['Marketing Digital', 'IA & Automatización', 'Redes Sociales', 'Educación Online'],
    button: 'Conocer Más',
    floating: {
      title: 'Fundadora & CEO',
      subtitle: 'Smart Business'
    }
  },
  services: {
    badge: 'Lo Que Hacemos',
    titlePrefix: 'Nuestros',
    titleHighlight: 'Servicios',
    subtitle: 'Soluciones digitales completas para hacer crecer tu negocio en el mundo online con estrategias de marketing digital probadas.',
    popular: 'Más Popular',
    more: 'Ver más',
    allButton: 'Ver Todos los Servicios',
    items: {
      web: {
        title: 'Creación de Sitio Web + Hosting',
        desc: 'Sitios web modernos y de alta conversión con optimización móvil, estructura SEO y hosting incluido.'
      },
      crm: {
        title: 'Creación de CRM',
        desc: 'Sistemas CRM personalizados para gestionar leads, clientes, flujos de trabajo y operaciones internas.'
      },
      branding: {
        title: 'Branding & Diseño',
        desc: 'Identidad de marca con logos, paletas de colores, dirección visual y materiales de marketing.'
      },
      socialConsulting: {
        title: 'Consultoría en Redes Sociales',
        desc: 'Orientación estratégica para que tu negocio crezca y se posicione efectivamente en redes sociales.'
      },
      content: {
        title: 'Consultoría de Contenido',
        desc: 'Guía para crear contenido estratégico y atractivo que conecta con tu audiencia y convierte.'
      },
      optimization: {
        title: 'Optimización de Redes Sociales',
        desc: 'Optimización de perfiles en redes sociales para mejorar claridad, branding y conversión.'
      },
      google: {
        title: 'Perfil de Google Business',
        desc: 'Configuración y optimización de tu Perfil de Google Business para mejorar la visibilidad local.'
      },
      automation: {
        title: 'Automatización con IA & Funnels',
        desc: 'Sistemas automatizados, funnels y flujos de trabajo con IA que trabajan las 24 horas del día.'
      },
      strategy: {
        title: 'Consultoría & Estrategia',
        desc: 'Sesiones de consultoría personalizadas enfocadas en crecimiento, estrategia digital y ejecución.'
      },
      business: {
        title: 'Consultoría Empresarial',
        desc: 'Formación de LLC, licencias, estructura empresarial y red de profesionales desde el primer día.'
      }
    }
  },
  products: {
    badge: 'Tienda Digital',
    titlePrefix: 'Productos &',
    titleHighlight: 'Ofertas',
    categories: {
      courses: 'Cursos',
      products: 'Productos',
      workshops: 'Talleres',
      services: 'Servicios'
    },
    items: {
      socialMastery: {
        title: 'Social Media Mastery',
        desc: 'Aprende a crear contenido viral y crecer tu audiencia en Instagram, TikTok y Facebook desde cero.',
        cta: 'Comprar Ahora',
        badge: 'Más Vendido'
      },
      aiAutomation: {
        title: 'AI Business Automation',
        desc: 'Domina las herramientas de IA para automatizar tu negocio y multiplicar tus ingresos.',
        cta: 'Comprar Ahora',
        badge: 'Nuevo'
      },
      contentCalendar: {
        title: 'Content Calendar Template',
        desc: 'Plantilla profesional de calendario de contenido para planificar 30 días de publicaciones.',
        cta: 'Comprar Ahora'
      },
      brandKit: {
        title: 'Brand Kit Completo',
        desc: 'Kit de marca digital con plantillas de Canva, guía de colores y tipografías para tu negocio.',
        cta: 'Comprar Ahora'
      },
      launchBusiness: {
        title: 'Workshop: Lanza Tu Negocio',
        desc: 'Taller en vivo de 3 horas para lanzar tu negocio digital desde cero con estrategia.',
        cta: 'Inscribirme',
        badge: 'En Vivo'
      },
      emailMarketing: {
        title: 'Masterclass: Email Marketing',
        desc: 'Aprende a construir tu lista de emails y crear campañas que generan ventas automáticas.',
        cta: 'Inscribirme'
      },
      consulting1on1: {
        title: 'Consultoría 1:1',
        desc: 'Sesión privada de 60 minutos para revisar tu estrategia digital y crear un plan de acción.',
        cta: 'Reservar',
        badge: 'Premium'
      },
      socialManagement: {
        title: 'Gestión de Redes Sociales',
        desc: 'Servicio mensual completo de manejo de tus redes sociales con estrategia y contenido.',
        cta: 'Contratar',
        priceSuffix: '/mes'
      }
    }
  },
  academy: {
    badge: 'Academia Online',
    titleMain: 'Smart Business',
    titleHighlight: 'Academy',
    subtitle: 'Aprende a construir múltiples fuentes de ingresos en línea. La academia diseñada para emprendedores latinos que quieren dominar el mundo digital.',
    benefits: [
      'Cursos de marketing digital y redes sociales',
      'Estrategias de IA y automatización de negocios',
      'Comunidad privada de emprendedores',
      'Mentorías en vivo con Cathy Roldán',
      'Certificados digitales reconocidos'
    ],
    button: 'Explorar la Academia',
    visual: {
      module: 'Módulo 1: Fundamentos',
      topic: 'Marketing Digital para Negocios',
      completed: 'completado',
      status: 'En progreso'
    },
    stats: {
      students: 'Estudiantes',
      rating: 'Rating'
    }
  },
  testimonials: {
    badge: 'Testimonios',
    titlePrefix: 'Lo Que Dicen Nuestros',
    titleHighlight: 'Clientes',
    subtitle: 'Historias reales de emprendedores que transformaron sus negocios con nuestras estrategias de marketing digital.',
    items: [
      {
        name: 'María González',
        role: 'Dueña de Boutique Online',
        location: 'Miami, FL',
        text: 'Gracias a Cathy y su equipo, mi boutique online pasó de 200 a más de 5,000 seguidores en 3 meses. Las ventas aumentaron un 300%. ¡Increíble!'
      },
      {
        name: 'Carlos Mendoza',
        role: 'Coach de Fitness',
        location: 'Los Angeles, CA',
        text: 'La automatización con IA que implementaron en mi negocio me ahorra 20 horas a la semana. Ahora puedo enfocarme en lo que amo: entrenar a mis clientes.'
      },
      {
        name: 'Ana Rodríguez',
        role: 'Consultora de Negocios',
        location: 'New York, NY',
        text: 'El curso de Social Media Mastery cambió completamente mi perspectiva. En 6 semanas lancé mi marca personal y conseguí mis primeros 10 clientes.'
      },
      {
        name: 'Roberto Silva',
        role: 'Restaurantero',
        location: 'Houston, TX',
        text: 'Smart Business Digital Solutions transformó la presencia online de mi restaurante. Ahora tenemos reservaciones llenas cada fin de semana gracias a las redes sociales.'
      },
      {
        name: 'Valentina Torres',
        role: 'Creadora de Contenido',
        location: 'Chicago, IL',
        text: 'La Academia de Smart Business me dio todas las herramientas para monetizar mi contenido. En 4 meses ya genero ingresos pasivos con mis cursos digitales.'
      }
    ]
  },
  cta: {
    badge: '¿Listo para Crecer?',
    titlePrefix: 'Comienza Tu Negocio',
    titleHighlight: 'Digital Hoy',
    subtitle: 'Únete a cientos de emprendedores latinos que ya están escalando sus negocios con marketing digital, IA y sistemas automatizados.',
    buttons: {
      academy: 'Unirse a la Academia',
      consult: 'Reservar Consulta',
      services: 'Ver Servicios'
    },
    indicators: [
      'Garantía de Satisfacción',
      'Soporte Personalizado',
      'Comunidad Global'
    ]
  },
  trust: {
    badge: 'Confianza Global',
    title: 'Confiado por emprendedores en todo el mundo',
    stats: {
      students: 'Estudiantes Activos',
      clients: 'Clientes Atendidos',
      years: 'Años de Experiencia',
      satisfaction: 'Satisfacción'
    },
    platforms: 'Plataformas que dominamos'
  }
};

export default home;
